import { Injectable } from '@angular/core';
import { BaseGridService } from 'ngx-mt-ui-lib/services/base-grid';
import { Filters, IGridSorting } from 'ngx-mt-ui-lib/interfaces';
import { GRID_ID } from '@app/app.enums';
import { ECriteria } from 'ngx-mt-ui-lib/enums';
import { IEventLogChangeHistoryGridItem } from '@app/core/interfaces/event-log';

export type TSystemParamsHistoryGridFilters = {
  objectId: Filters.TFilterModel<'objectId', string>;
};

@Injectable()
export class SystemParamsHistoryGridService extends BaseGridService<
  IEventLogChangeHistoryGridItem,
  TSystemParamsHistoryGridFilters
> {
  public readonly gridId = GRID_ID['ADMIN.SYSTEM_PARAMS.HISTORY'];

  protected override readonly defaultFilters: TSystemParamsHistoryGridFilters =
    {
      objectId: {
        field: 'objectId',
        value: null,
        criteria: ECriteria.equals,
      },
    };

  protected override readonly defaultSorting: IGridSorting[] = [
    {
      field: 'eventLogStartDate',
      direction: 'desc',
      index: 0,
    },
  ];

  constructor() {
    super();
    this.init();
  }
}
